import classNames from "classnames";
import { Avatar } from "components/DesignSystem/AvatarGroup/Avatar";
import { VendorDefault } from "components/icons/VendorDefault";
import { motion } from "framer-motion";
import { useRef, useState } from "react";
import { Row } from "react-table-8.10.7";
import { Transactions as TransactionsType } from "types/Models/books";

type Props = {
  row: Row<TransactionsType>;
  onAnimateComplete(): void;
};

export const TransactionAnimateRow = ({ row, onAnimateComplete }: Props) => {
  const content = useRef<null | HTMLTableRowElement>(null);
  const [refAvailable, setRefAvailable] = useState(false);

  return (
    <motion.tr
      className={classNames(
        "t-cursor-pointer t-absolute t-overflow-hidden t-rounded-md t-z-[9999] t-w-14 t-h-14"
      )}
      ref={(ref) => {
        content.current = ref;
        setRefAvailable(true);
      }}
      animate={
        refAvailable
          ? {
              opacity: [null, 0],
              x: [
                null,
                document.body.getBoundingClientRect().right -
                  200 -
                  (content.current?.getBoundingClientRect()?.right ?? 0),
              ],
              y: [
                null,
                document.body.getBoundingClientRect().bottom -
                  32 -
                  (content.current?.getBoundingClientRect()?.bottom || 0),
              ],
            }
          : {}
      }
      transition={{
        type: "tween",
        duration: 0.6,
        ease: "easeInOut",
      }}
      onAnimationComplete={() => {
        onAnimateComplete();
      }}
    >
      {row.getVisibleCells().map((cell) => {
        const merchant = row.original.transaction.merchant;

        return (
          <td
            key={cell.id}
            style={{
              width: "100px",
              opacity: 1,
            }}
          >
            <div className="t-flex t-gap-2 t-items-center t-border t-border-solid t-border-neutral-30 t-w-7 t-h-7 t-justify-center t-rounded-full">
              {merchant ? (
                <Avatar
                  src={row.original.transaction.logo || ""}
                  alt={merchant}
                />
              ) : (
                <VendorDefault />
              )}
            </div>
          </td>
        );
      })}
    </motion.tr>
  );
};
